//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '~/components/Shared/Button'
import ModalBase from '~/components/Shared/ModalBase.vue'

export default {
  components: { Button, ModalBase },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  computed: {
    oldSupervisor() {
      return `${this.row?.oldSupervisor?.names || ''} ${
        this.row?.oldSupervisor?.lastnames || ''
      }`
    },
    newSupervisor() {
      return `${this.row?.newSupervisor?.names || ''} ${
        this.row?.newSupervisor?.lastnames || ''
      }`
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    confirm() {
      this.close()
      this.$emit('confirm')
    },
  },
}
